<ng-container *ngIf="{isLoadingLanguage: isLoadingLanguage$ | async} as isLoadingLanguageObj">
  <div *ngFor="let language of availableLanguages" (click)="changeLang(language)" class="language language_{{language}}"
    [class.loading]="language === isLoadingLanguageObj.isLoadingLanguage"
    [class.active]="currentLanguage === language">
    <mat-spinner *ngIf="language === isLoadingLanguageObj.isLoadingLanguage" diameter="20" color="primary">
    </mat-spinner>
  </div>
</ng-container>
